var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSmallInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 8C6.5 8.276 6.276 8.5 6 8.5C5.724 8.5 5.5 8.276 5.5 8L5.5 5.5C5.5 5.224 5.724 5 6 5C6.276 5 6.5 5.224 6.5 5.5L6.5 8ZM6.5 4C6.5 4.276 6.276 4.5 6 4.5C5.724 4.5 5.5 4.276 5.5 4C5.5 3.724 5.724 3.5 6 3.5C6.276 3.5 6.5 3.724 6.5 4ZM6 2C8.2055 2 10 3.7945 10 6C10 8.2055 8.2055 10 6 10C3.7945 10 2 8.2055 2 6C2 3.7945 3.7945 2 6 2ZM6 11C8.7615 11 11 8.7615 11 6C11 3.2385 8.7615 1 6 1C3.2385 0.999999 1 3.2385 1 6C1 8.7615 3.2385 11 6 11Z",
    fill: "#E44E45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSmallInfo);
export default __webpack_public_path__ + "static/media/icon_small_info.454e2a7846b31783cd99f9a620340c5d.svg";
export { ForwardRef as ReactComponent };